import { createStore } from "vuex";
import type { Store } from "vuex";
import type { State } from "@/store/state";

import { mainModule } from "@/store/main";
import { adminModule } from "@/store/admin";
import { mapModule } from "@/store/worldmap";
import { siteConfigModule } from "@/store/siteconfig";
import { devicesModule } from "@/store/devices";
import { assetsModule } from "@/store/assets";
import { activitiesModule } from "@/store/activities";
import { modelParametersModule } from "@/store/modelparameter";

export const store: Store<State> = createStore<State>({
  strict: process.env.NODE_ENV !== "production", // throw an error whenever state is mutated outside of a mutation handler
  modules: {
    main: mainModule,
    siteConfig: siteConfigModule,
    map: mapModule,
    activities: activitiesModule,
    admin: adminModule,
    devices: devicesModule,
    assets: assetsModule,
    modelParameters: modelParametersModule,
  },
});

export default store;
